<template>
  <div class="user-modal-wrapper">
    <div class="user-modal">
      <form @submit.prevent>
        <p>НАСТРОЙКИ НА ПРОЕКТА</p>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="isActive" />
              <span class="slider"></span>
            </label>
          </div>
          <div class="texts">
            <p>Активен проект</p>
            <p>
              Изберете дали проекта да се вижда или не при създаване на отчет
            </p>
          </div>
        </div>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="isExternal" />
              <span class="slider"></span>
            </label>
          </div>
          <div class="texts">
            <p>За външни потребители</p>
            <p>
              Изберете дали в проекта да може да се отчитат външни работници
            </p>
          </div>
        </div>
        <div class="row">
          <ColorPicker v-model="color" />
          <div class="texts">
            <p>Цвят на проекта</p>
            <p>Изберете цвета с който да излиза проекта във Форма 76</p>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="texts">
            <p>Мейл нотификации за отчети и справки при външни проекти</p>
            <p>Общи настройки за добавените мейли към проекта</p>
          </div>
        </div>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                :disabled="!isExternal"
                :checked="blacklist.indexOf(getUser._id) > -1"
                @input="handleBlacklistInput"
              />
              <span
                class="slider"
                :class="{ 'slider--disabled': !isExternal }"
              ></span>
            </label>
          </div>
          <div class="texts">
            <p>Без нотификации за мои отчети към мен</p>
          </div>
        </div>
        <div class="row">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                :disabled="!isExternal"
                v-model="timingOfWeeklyInquiry.enabled"
              />
              <span
                class="slider"
                :class="{ 'slider--disabled': !isExternal }"
              ></span>
            </label>
          </div>
          <div class="texts">
            <p>Седмична справка за външни<br />проекти да се изпраща в</p>
          </div>

          <div class="switchers">
            <!-- :disabled="" -->
            <Switcher
              v-model="timingOfWeeklyInquiry.day"
              title="Кликнете или скролнете за избор на ден от седмицата"
              :disabled="!timingOfWeeklyInquiry.enabled || !isExternal"
              :list="[
                'Неделя',
                'Понеделник',
                'Вторник',
                'Сряда',
                'Четвъртък',
                'Петък',
                'Събота',
              ]"
            />
            <Switcher
              v-model="timingOfWeeklyInquiry.hour"
              title="Кликнете или скролнете за избор на час за получаване"
              :disabled="!timingOfWeeklyInquiry.enabled || !isExternal"
              :list="getHours"
            />
          </div>
        </div>
        <hr />
        <div class="table-emails__wrapper" v-if="isExternal">
          <table class="table-emails">
            <thead>
              <tr>
                <th>
                  Добавете един или повече мейли, които да получават нотификация
                  при изброените събития
                </th>
                <th>ОТЧЕТ<br />създаване</th>
                <th>ОТЧЕТ<br />редакция</th>
                <th>Седмична<br />СПРАВКА</th>
                <th>Таб<br />доставки</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ns, i) in externalNotifications" :key="`ns-${i}`">
                <td>
                  <p v-if="ns.name">{{ ns.name }}</p>
                  <div class="emails-input" v-else>
                    <input
                      type="text"
                      placeholder="e-mail"
                      :disabled="!isExternal"
                      v-model.trim="ns.email"
                      @input="checkInput($event)"
                      @keydown.enter.prevent
                    />
                  </div>
                </td>
                <td>
                  <TheInput
                    type="checkbox"
                    :disabled="!isExternal"
                    v-model="ns.reportCreation"
                    @change="setValue($event, ns, 'reportCreation')"
                  />
                </td>
                <td>
                  <TheInput
                    type="checkbox"
                    :disabled="!isExternal"
                    v-model="ns.reportEdit"
                    @change="setValue($event, ns, 'reportEdit')"
                  />
                </td>
                <td>
                  <TheInput
                    type="checkbox"
                    :disabled="!isExternal"
                    v-model="ns.weeklyInquiry"
                    @change="setValue($event, ns, 'weeklyInquiry')"
                  />
                </td>
                <td>
                  <TheInput
                    type="checkbox"
                    :disabled="!isExternal"
                    v-model="ns.deliveriesMails"
                    @change="setValue($event, ns, 'deliveriesMails')"
                  />
                </td>
                <td>
                  <span
                    v-if="!ns.name"
                    class="mck icon--delete"
                    @click="removeRow(i)"
                    >b</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row">
          <span class="add-toggle" @click="addRow">+</span>
        </div>
        <div class="user-modal-actions">
          <div class="btns">
            <button class="btn btn-close" @click.prevent="close()">
              <span class="mck">F</span>
              Отказ
            </button>
            <button
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save"
            >
              <span class="mck">Y</span>
              Запис
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ColorPicker from "./ColorPicker.vue";
import Switcher from "./Switcher.vue";
import TheInput from "../TheInput.vue";
export default {
  components: {
    ColorPicker,
    Switcher,
    TheInput,
  },
  props: ["project"],
  computed: {
    ...mapGetters(["getUser"]),
    getHours() {
      const hours = [];
      for (let i = 0; i < 24; i++) {
        hours.push(`0${i}:00`.slice(-5));
      }
      return hours;
    },
  },
  data() {
    return {
      isActive: false,
      isExternal: false,
      color: null,
      blacklist: [],
      emailNotifications: "",
      externalNotifications: [],
      timingOfWeeklyInquiry: {
        enabled: false,
        day: 0,
        hour: 0,
      },
    };
  },
  methods: {
    setValue(v, ns, field) {
      this.$set(ns, field, v);
    },
    handleBlacklistInput(e) {
      if (e.target.checked) {
        this.blacklist.push(this.getUser._id);
      } else {
        const i = this.blacklist.indexOf(this.getUser._id);
        if (i > -1) this.blacklist.splice(i, 1);
      }
    },
    addRow() {
      // TODO
      if (!this.isExternal) {
        return this.$snotify.warning("Проектът не е за външни потребители");
      }
      this.externalNotifications.push({
        email: "",
        reportCreation: false,
        reportEdit: false,
        weeklyInquiry: false,
        deliveriesMails: false,
      });
    },
    removeRow(i) {
      this.externalNotifications.splice(i, 1);
    },
    // can`t have space between mails in emailNotifications input
    checkInput(e) {
      this.emailNotifications = e.target.value.replace(/\s/g, "");
    },
    close(change) {
      this.$emit("close", change);
    },
    isValid() {
      if (this.isExternal) {
        if (!this.externalNotifications.length) {
          this.$snotify.warning("Трябва да въведете поне 1 e-mail");
          return false;
        }
        for (let en of this.externalNotifications) {
          if (!en.email) {
            this.$snotify.warning("Имате поне 1 липсващ e-mail");
            return false;
          }
          if (
            !en.email
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              )
          ) {
            this.$snotify.warning("Имате поне 1 неправилен e-mail");
            return false;
          }

          // if (
          //   !en.reportCreation &&
          //   !en.reportEdit &&
          //   !en.weeklyInquiry &&
          //   !en.deliveriesMails
          // ) {
          //   this.$snotify.warning(
          //     "Всеки добавен e-mail трябва да има поне 1 избран checkbox"
          //   );
          //   return false;
          // }
        }
      }
      return true;
    },
    save() {
      if (this.isValid()) {
        this.project.isActive = this.isActive;
        this.project.isExternal = this.isExternal;
        this.project.color = this.color;
        this.project.emailNotifications = this.emailNotifications;
        this.project.externalNotifications = this.isExternal
          ? this.externalNotifications
          : [];
        this.project.ownReportNotificationsBlacklist = this.blacklist;
        this.project.timingOfWeeklyInquiry = this.timingOfWeeklyInquiry;

        this.close(true);
      }
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        this.save();
      } else if (e.code === "Escape") {
        this.close();
      }
    },
    handleExternalNotifications() {
      const { reporters, externalNotifications } = this.project;

      const activeReporters = reporters
        .filter((r) => r.isSelected && r.isActive && r.email)
        .map((reporter) => ({
          name: reporter.name,
          email: reporter.email,
          reportCreation: false,
          reportEdit: false,
          weeklyInquiry: false,
          deliveriesMails: false,
        }));

      const mergedNotifications = [...externalNotifications];

      activeReporters.forEach((reporter) => {
        const existingReporter = mergedNotifications.find(
          (external) => external.email === reporter.email
        );

        if (!existingReporter) {
          mergedNotifications.push(reporter);
        } else {
          Object.assign(existingReporter, {
            name: reporter.name,
            email: reporter.email,
            reportCreation: existingReporter.reportCreation || false,
            reportEdit: existingReporter.reportEdit || false,
            weeklyInquiry: existingReporter.weeklyInquiry || false,
            deliveriesMails: existingReporter.deliveriesMails || false,
          });
        }
      });

      this.externalNotifications = mergedNotifications.sort((a, b) => {
        if (!a.name && b.name) return 1;
        if (a.name && !b.name) return -1;

        if (a.name && b.name) {
          return a.name.localeCompare(b.name);
        }

        return 0;
      });
    },
  },
  mounted() {
    this.isActive = this.project.isActive;
    this.isExternal = this.project.isExternal;
    this.color = this.project.color;
    this.emailNotifications = this.project.emailNotifications;

    this.handleExternalNotifications();

    this.blacklist = [...this.project.ownReportNotificationsBlacklist];
    if (this.project.timingOfWeeklyInquiry) {
      this.timingOfWeeklyInquiry = Object.assign(
        {},
        this.project.timingOfWeeklyInquiry
      );
    }

    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.user-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}
.user-modal {
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 98vh;
  padding: 20px 30px 0;
  width: 508px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.user-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.user-modal form > p {
  font-weight: 500;
  margin-bottom: 2rem;
  text-align: center;
}
.switchers {
  display: flex;
  flex-grow: 1;
  gap: 5px;
  padding-left: 5px;
  justify-content: flex-end;
}
.row {
  align-items: center;
  display: flex;
  margin: 5px 0;
  min-height: 35px;
}
.add-toggle {
  align-items: center;
  background: #005a9e;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 28px;
  height: 35px;
  justify-content: center;
  line-height: 28px;
  transition: 0.3s ease;
  user-select: none;
  width: 35px;
}
.add-toggle:hover {
  opacity: 0.8;
}
hr {
  background-color: #00000026;
  border: none;
  display: block;
  height: 1px;
  margin: 12px 0;
}
.table-emails__wrapper {
  max-height: 25vh;
  overflow: auto;
}
.table-emails {
  border: 0;
  border-spacing: 0;
}
.table-emails thead th {
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  font-weight: 400;
  padding-left: 10px;
  padding-bottom: 5px;
  width: 1%;
}
.table-emails thead th:first-child {
  text-align: left;
  padding-left: 0;
  width: 100%;
}
.table-emails tbody td {
  text-align: center;
  padding: 5px 0 5px 10px;
  width: 1%;
}
.table-emails tbody td:first-child {
  padding-left: 0;
  text-align: left;
  width: 100%;
}
.emails-input {
  position: relative;
  width: 100%;
}
.emails-input::after {
  color: #005a9e;
  content: "y";
  font-family: "mck2";
  font-size: 16px;
  font-weight: 700;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.emails-input input {
  background-color: #f4f4f4;
  border: 1px solid #cecece;
  border-radius: 4px;
  font-size: 12px;
  height: 35px;
  padding-left: 30px;
  transition: 0.3s ease;
  width: 100%;
}
.emails-input input:disabled {
  opacity: 0.25;
}
.row .texts p:not(:first-child) {
  font-size: 10px;
  opacity: 0.5;
}
.row > p {
  width: 100%;
}

/* .switch {
  margin: 0; 
} */
.slider {
  background-color: #b1b1b1;
}
.slider::before {
  bottom: 2px;
  height: 16px;
  left: 3px;
  width: 16px;
}
input:checked + .slider {
  background-color: var(--color-main);
}
input:checked + .slider:before {
  transform: translateX(22px);
}
/* .invalid .mck {
  color: #d91313;
} */
</style>
